<template>
    <div>
        <header-portrate />
        <div class="m-2 pa-2">
            <bread-crumbs :items="items" />
            <tabs-comp :tabs="tabs" />
            <div class="viewCell">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="lang.search_by_customer_or_tax"
                    hide-details
                ></v-text-field>
                <div class="text-left p-2">
                    <b-button
                        v-b-toggle.sendMessageToCustomer
                        class="btn-sm btn "
                        style="margin-top:11px;width:150px;background:transparent;border:none"
                        id="multiply-button"
                    >
                    <div style="width:150px;" :class="`multiply-button-content-`+lang.lalgin">{{ lang.send_message }}</div>

                    </b-button>

                    <b-button
                        v-b-toggle.billAddCustomer
                        class="btn-sm btn "
                        style="margin-top:11px;width:150px;background:transparent;border:none"
                        id="multiply-button"
                        @click="addCustomer({id: 0})"
                    >
                    <div style="width:150px;" :class="`multiply-button-content-`+lang.lalgin">{{ lang.add_customer }}</div>

                    </b-button>

                </div>

            </div>
            <v-row class=" d-md-flex">
                <v-col cols="12" style="direction: rtl;">
                    <v-data-table
                        :headers="headers"
                        :items="clientList"
                        :search="search"
                        :items-per-page="15"
                        :page.sync="page"
                        width="100%"
                        id="MainTable"
                        hide-default-footer
                        @page-count="pageCount = $event"
                        fixed-header
                        class="table-sm"
                    >
                        <template v-slot:item="row">
                        <tr>
                            <!-- <td style="border-bottom:1px solid #fff !important;text-align:center;direction:rtl;background:#000">
                                <b-button class="btn btn-sm" style="background:#000;color:#fff;border:none" @click="edit(row.item,3)" v-b-toggle.viewCRMCase>تعديل &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></b-button>
                            </td> -->
                            <!-- <td>{{parseFloat(index) + 1}}</td> -->
                            <td :style="`text-align:center;background:#000;color:#FFF !important;height:30px !important;width:75px !important;cursor:pointer;border-bottom:1px solid #fff !important;`" v-b-toggle.billAddCustomer @click="addCustomer(row.item)">
                                <div class="viewCell">{{ lang.view }} <i class="fas fa-caret-left"></i></div>
                            </td>
                            <td style="text-align:center;">{{ row.item.clientName }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.clientCRT }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.mobile }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.clientVAT }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.clientDomain }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.LastInvDate.substring(0,10) }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.lastMessageOpened }}</td>
                            <td style="text-align:center;direction:ltr" nowrap>{{ row.item.expireDate.substring(0,10) }}</td>
                            <td style="text-align:center;" nowrap>{{ row.item.address }}</td>
                            <td :style="`text-align:center;background:${row.item._supportBack};color:${row.item._supportColor}`" nowrap> {{row.item._supportStatus}} </td>
                            <td :style="`text-align:center;background:${row.item._statusColor};color:#FFF !important;width:120px`" nowrap>{{ row.item._status }}</td>
                        </tr>
                        </template>
                    </v-data-table>

                    </v-col>
                    <v-col cols="12" style="margin-bottom:25px;margin-top:-15px;">

                    <v-container>
                        <div class="text-center pt-2">
                        <v-pagination
                            v-model="page"
                            value="10"
                            :length="pageCount"
                        ></v-pagination>
                        </div>
                    </v-container>
                </v-col>
            </v-row>

        </div>
        <sendMessageToCustomer ref="sendMsgTus" />
        <bill-add-customer ref="addCustomer" />
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import BreadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import sendMessageToCustomer from '@/components/sendMessageToCustomers'
import billAddCustomer from '@/components/bill/billAddCustomer.vue'
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
    name: 'BillClients',
    components:{HeaderPortrate,BreadCrumbs,TabsComp,sendMessageToCustomer,billAddCustomer},
    data() {
        return {
            search: '',
            page:1,
            pageCount: 0,
            clientList: []
        }
    },
    computed:{
        ...mapGetters({
            billState: `billStore/billState`
        }),
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return {
                text: this.lang.clients_list,
                disabled: true,
                href: '/',
            }
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        tableData: function(){
            return this.billState.clientList;
        },
        headers: function(){
            return [
                {
                    text: this.lang.action,
                    align: 'center',
                    filterable: false,
                    sortable:false,
                    value: 'center'
                },
                {
                    text: this.lang.client,
                    align: 'center',
                    sortable:false,
                    value: 'clientName',
                },
                {
                    text: this.lang.register_number,
                    align: 'center',
                    sortable:false,
                    value: 'clientCRT'
                },
                {
                    text: this.lang.mobile,
                    align: 'center',
                    sortable:true,
                    value: 'clientCRT'
                },
                {
                    text: this.lang.tax_number,
                    align: 'center',
                    sortable:false,
                    value: 'clientVAT'
                },
                {
                    text: this.lang.domain,
                    align: 'center',
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.last_invoice,
                    align: 'center',
                    filterable: false,
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.receive_messages,
                    align: 'center',
                    filterable: false,
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.expiration_date,
                    align: 'center',
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.address,
                    align: 'center',
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.support_status,
                    align: 'center',
                    sortable:false,
                    value: ''
                },
                {
                    text: this.lang.activity_status,
                    align: 'center',
                    sortable:false,
                    value: ''
                },
            ]
        }
    },
    methods: {
        async getClientList(){
            const post = new FormData();
            post.append('type','getCheckClient');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('data[ids]','0');
            post.append('auth',this.$cookies.get('SAMCCCC-Cookies'));
            const response = await axios.post(
                '/api/index.php',post
            )
            if(response && response.data){
                this.clientList = response.data.results.data;
            }

        },
        sendMsgTus() {
            this.$refs.sendMsgTus.customerList = [];
            this.$refs.sendMsgTus.message = '';
            this.$refs.sendMsgTus.clientStatus = 0;
        },
        addCustomer(item){
            if(item.id == 0){
                this.$refs.addCustomer.blockname = this.lang.add_customer;
                this.$refs.addCustomer.buttonName = this.lang.add;
                this.$refs.addCustomer.itemView = {
                    id: 0,
                    clientType: "ecars",
                    clientName: "",
                    clientCRT: "",
                    clientVAT: "",
                    clientDomain: "",
                    expireDate: "",
                    anyDesk: "",
                    databasename: ""
                };
            }else{
                this.$refs.addCustomer.blockname = this.lang.edit_customer;
                this.$refs.addCustomer.buttonName = this.lang.edit;
                this.$refs.addCustomer.itemView = item;
            }
        }
    },
    async created(){
       await this.getClientList();
    }
}
</script>
<style>
.viewCell{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
}
</style>